import { ArrowLeft, ArrowRight } from "lucide-react";

type Props = {
  onPrev: () => void;
  onNext: () => void;
};

/** Previous/next navigation buttons for homepage carousels. */
export const CarouselNavButtons = ({ onPrev, onNext }: Props) => (
  <>
    <button
      type="button"
      aria-label="Previous"
      onClick={onPrev}
      className="hover:border-dark flex size-3.5 cursor-pointer items-center justify-center rounded-full border border-neutral-500 bg-white transition-colors"
    >
      <ArrowLeft size={12} className="text-icon-secondary" />
    </button>
    <button
      type="button"
      aria-label="Next"
      onClick={onNext}
      className="hover:border-dark flex size-3.5 cursor-pointer items-center justify-center rounded-full border border-neutral-500 bg-white transition-colors"
    >
      <ArrowRight size={12} className="text-icon-secondary" />
    </button>
  </>
);
